import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

const TOKEN = "tr3nd_token";
const ADMIN_TOKEN = "tr3nd_admin_token";
const IMP_NAME = "tr3nd_impersonating";
const IMP_BACK = "tr3nd_impersonating_back";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = verificando, false = deslogado
  const [checked, setChecked] = useState(false);
  const [impersonating, setImpersonating] = useState(
    () => localStorage.getItem(IMP_NAME) || ""
  );

  useEffect(() => {
    const token = localStorage.getItem(TOKEN);
    if (!token) {
      setUser(false);
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem(TOKEN);
        setUser(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN, data.access_token);
    setUser(data.user);
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem(TOKEN, data.access_token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignora */
    }
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(ADMIN_TOKEN);
    localStorage.removeItem(IMP_NAME);
    setImpersonating("");
    setUser(false);
  };

  // Visualização administrativa: a sessão admin fica guardada em paralelo.
  const startImpersonation = async (partnerId) => {
    const { data } = await api.post(`/partners/${partnerId}/impersonate`);
    localStorage.setItem(ADMIN_TOKEN, localStorage.getItem(TOKEN));
    localStorage.setItem(TOKEN, data.access_token);
    localStorage.setItem(IMP_NAME, data.partner.name);
    localStorage.setItem(IMP_BACK, "/parceiros");
    setImpersonating(data.partner.name);
    setUser(data.user);
    return data;
  };

  const startCreatorImpersonation = async (creatorId) => {
    const { data } = await api.post(`/creators/${creatorId}/impersonate`);
    localStorage.setItem(ADMIN_TOKEN, localStorage.getItem(TOKEN));
    localStorage.setItem(TOKEN, data.access_token);
    localStorage.setItem(IMP_NAME, data.creator.name);
    localStorage.setItem(IMP_BACK, "/criadoras");
    setImpersonating(data.creator.name);
    setUser(data.user);
    return data;
  };

  const stopImpersonation = () => {
    const adminToken = localStorage.getItem(ADMIN_TOKEN);
    const back = localStorage.getItem(IMP_BACK) || "/parceiros";
    if (adminToken) localStorage.setItem(TOKEN, adminToken);
    localStorage.removeItem(ADMIN_TOKEN);
    localStorage.removeItem(IMP_NAME);
    localStorage.removeItem(IMP_BACK);
    setImpersonating("");
    window.location.href = back;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        checked,
        login,
        register,
        logout,
        apiError,
        impersonating,
        startImpersonation,
        startCreatorImpersonation,
        stopImpersonation,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
